/* eslint-disable max-lines */
import {
  ICustomFieldsService,
  CreateCustomFieldParams,
  CustomFieldsResponseType,
  UpdateCustomFieldParams,
  FileMetaData,
  CustomFieldEntity,
  CustomField
} from './contracts/customFields.service';

import apiClient from '../../api/index';
import { createUrl } from '_clean-code/utils/urlHelper';

const CustomFieldsService: ICustomFieldsService = {
  createCustomField: async (params: CreateCustomFieldParams): Promise<void> => {
    const response = await apiClient.request(
      'POST',
      createUrl('/custom-fields').toStringUrl(),
      params
    );

    return response as void;
  },

  fetchCustomFields: async (
    params: string
  ): Promise<CustomFieldsResponseType> => {
    const response = await apiClient.request(
      'GET',
      createUrl(`/custom-fields/${params}`).toStringUrl()
    );
    return response as CustomFieldsResponseType;
  },

  deleteCustomField: async (params: string): Promise<void> => {
    const response = await apiClient.request(
      'DELETE',
      createUrl(`/custom-fields/${params}`).toStringUrl()
    );
    return response as void;
  },

  downloadFile: async (params: string): Promise<FileMetaData> => {
    const response = await apiClient.request(
      'GET',
      createUrl(`/custom-field-values/download/${params}`).toStringUrl()
    );
    return response as FileMetaData;
  },
  updateCustomField: async (params: UpdateCustomFieldParams): Promise<void> => {
    const response = await apiClient.request(
      'PATCH',
      createUrl(`/custom-fields/${params.id}`).toStringUrl(),
      {
        name: params.name,
        config: params.config,
        default: params.default
      }
    );
    return response as void;
  },
  getCustomFields: async (
    entity: CustomFieldEntity
  ): Promise<{ entity: CustomFieldEntity; value: CustomField[] }> => {
    const response = await apiClient.request(
      'GET',
      createUrl(`/custom-fields/${entity}`).toStringUrl()
    );
    if (response && response[entity]) {
      const keys = Object.keys(response[entity]);
      return {
        entity,
        value: keys.map((key) => {
          const customField = response[entity][key];
          return {
            id: customField.id,
            name: customField.name,
            type: customField.type,
            config: customField.config,
            default: customField.default
          };
        })
      };
    }
    return { entity, value: [] };
  },
  uploadFile: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.request(
      'POST',
      createUrl('/custom-field-values/upload').toStringUrl(),
      formData,
      { isFileUpload: true }
    );
    return response as string;
  }
};

export default CustomFieldsService;
